import React from "react";

// External
import Switch from "@material-ui/core/Switch";
import Grid from "@material-ui/core/Grid";

// Local
import { BoxRow } from "../../styled/styled";

const ViewControls = ({
  actions,
  currentStepValue,
  currentProjection,
  projection
}) => {
  // const ButtonClick = styled.button`
  //   background-color: ${p =>
  //     !p.selected ? colorScheme.primaryColor : colorScheme.neutralLightColor};
  //   border: 1px solid ${colorScheme.neutralLightColor};
  //   border-radius: 4px;
  //   margin: 0 0.5em 0 0;
  //   padding: 0.5em;
  //   font-family: "Lato", serif;
  //   font-size: 1em;
  //   color: ${p =>
  //     !p.selected ? colorScheme.neutralLightColor : colorScheme.primaryColor};
  //   cursor: pointer;

  //   &:hover {
  //     background-color: transparent;
  //     border: 1px solid ${colorScheme.neutralLightColor};
  //     color: ${colorScheme.neutralLightColor};
  //   }
  // `;

  return (
    <>
      {currentStepValue > 1 ? (
        [
          // <BoxRow>
          //   <ButtonClick
          //     onClick={() => actions.switchProjection("geo")}
          //     selected={currentProjection === "geo"}
          //   >
          //     World
          //   </ButtonClick>
          //   <ButtonClick
          //     onClick={() => actions.switchProjection("tsne")}
          //     selected={currentProjection === "tsne"}
          //   >
          //     Clusters
          //   </ButtonClick>
          // </BoxRow>,
          <BoxRow style={{ alignContent: "flex-start" }}>
            <Grid component="label" container alignItems="center" spacing={1}>
              <Grid item>Clusters</Grid>
              <Grid item>
                <Switch
                  checked={currentProjection === "geo"}
                  onChange={() => actions.toggleProjection()}
                  value="checked"
                  color="default"
                />
              </Grid>
              <Grid item>World</Grid>
            </Grid>
          </BoxRow>
        ]
      ) : (
        <BoxRow style={{ height: "80px" }} />
      )}
    </>
  );
};

export default ViewControls;
